<template>
  <div class="help-friend-page">
    <div class="banner">
      <img
        class="helpfriend-banner"
        src="../assets/img/helpfriend-banner.png"
        alt=""
      />
    </div>
    <div class="wrapper">
      <!-- 小球，小背景 -->
      <div class="ball1"></div>
      <div class="ball2"></div>
      <div class="small-bg"></div>
      <div></div>
      <!-- 注册框 -->
      <div class="register">
        <div class="register-title">
          <p>
            <span>好友 </span><span>{{ this.friendName }}</span
            ><span> 邀您助力，增值版激活码免费拿</span>
          </p>
        </div>
        <!-- 注册 -->
        <div class="loginForm-box" style="display: block">
          <div class="phoneNum-verify-wrap">
            <input
              type="text"
              class="phone-number"
              placeholder="输入手机号码"
              v-model="phoneNumber"
            />
            <p class="veriPhone" v-show="showPhoneTip">{{ this.veriPhone }}</p>
          </div>
          <div class="img-verify-wrap">
            <input
              type="text"
              placeholder="输入图形验证码"
              class="imgCodeIpt"
              v-model="imgCodeNumber"
            />
            <img :src="randomImg" id="img-code" @click="changeImgCode" />
            <p class="veriImg" v-show="showImgTip">{{ this.veriImg }}</p>
          </div>
          <div class="phone-verify-wrap">
            <input
              type="text"
              class="veri-code"
              placeholder="输入手机验证码"
              v-model="codeNumber"
              maxlength="6"
            />
            <p class="veriCode" v-show="showCodeTip">{{ this.veriCode }}</p>
            <!-- <div class="btn-message">获取短信验证码</div> -->
            <div v-if="!isCounting" class="btn-message" @click="sendCode">
              {{ this.veriBtn }}
            </div>
            <div v-if="isCounting" class="veri-btn-counting">
              {{ this.veriBtn }}
            </div>
          </div>
          <div class="btn-wrap"></div>
          <div class="next-btn" @click="handleNext">下一步</div>
        </div>
        <p v-if="isNewUser" class="new-user-box">
          抱歉，您是注册老用户，无法为好友助力哦~
        </p>
        <!-- 激活成功 -->
        <div style="display: none" class="successForm-box">
          <div class="info">
            <p><span>非常感谢！您的助力已完成</span><span>80%</span></p>
            <p>进入开发者中心完成试用码激活即助力成功</p>
          </div>
          <div><a class="active-btn" href="https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/index" target="_blank"
            >前往激活</a></div>
          <a href="https://ai.arcsoft.com.cn/manual/docs#/247" target="_blank"
            >如何激活助力</a
          >
        </div>
      </div>
      <!-- 二维码 -->
      <div class="code-area">
        <p>邀您行业交流·参与幸运抽奖</p>
        <img src="../assets/img/qrcode1.png" alt="" />
        <p class="pc-p">扫码入群，与行业专家交流、参与社群抽奖活动</p>
        <div>
          <p>扫码入群</p>
          <p>与行业专家交流、参与社群抽奖活动</p>
        </div>
      </div>
      <!-- 活动规则 -->
      <div class="activity-rule">
        <p class="title">活动规则</p>
        <div class="activity-time">
          <img src="../assets/img/time.png" alt="" />
          <p class="time-title">活动时间</p>
          <p class="fs14 lsp3 lsp1">2021年6月23日-7月8日</p>
        </div>
        <div class="activity-group">
          <img src="../assets/img/group.png" alt="" />
          <p class="group-title">参与人群</p>
          <p class="fs14 lsp3 lsp1">平台内所有用户</p>
        </div>
        <div class="prize-rule mb">
          <img src="../assets/img/icon2.png" alt="" />
          <p class="prize-title">规则</p>
        </div>
        <p class="prize-cont">
          活动期间，新老用户加入行业交流群，即可参与社群内抽奖活动，奖品为实物奖品（价值80元）；中奖后分享至朋友圈，并截图联系虹助手领取。
        </p>
        <div class="prize-rule mb">
          <img src="../assets/img/icon1.png" alt="" />
          <p class="prize-title send">实物奖品发送</p>
        </div>
        <p class="first-title">
          <span>1.</span>
          在社群抽奖活动中，因奖品有限，每位用户仅限获得1次奖品，如多次中奖，则以第1次中奖奖品为准；
        </p>
        <p class="first-title">
          <span>2.</span>
          获得实物奖品的用户，虹助手将及时联系并核实寄送地址，在活动结束后30个工作日内寄出奖品。
        </p>
        <p class="notices">注意事项</p>
        <p class="first-title">
          1.对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖的用户，虹软视觉开放平台有权取消其获奖资格或其因参加活动所获权益；
        </p>
        <p class="first-title mt">
          2.虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: "",
      },
      isNewUser: false,
      friendName: "130****4567",
      showCodeTip: false,
      showPhoneTip: false,
      showInviteTips: false,
      showImgTip: false,
      isCounting: false,
      isImgCodeTrue: false,
      veriPhone: "",
      veriCode: "",
      veriImg: "",
      phoneNumber: "",
      codeNumber: "",
      imgCodeNumber: "",
      randomImg: "/ucenter/api/authimage",
      veriBtn: "获取短信验证码",
      inviteCode: "",
    };
  },
  created() {
    var url = window.location.href;
    var index = url.indexOf("?");
    this.inviteCode = url.slice(index + 12);
    this.$axios
      .post("/operator/new-version/queryPhoneByLink", {
        inviteCode: this.inviteCode,
      })
      .then((res) => {
        if (res.data.success == true) {
          this.friendName = res.data.retObj;
        } else {
        }
      });
  },
  methods: {
    //用户登录
    async handleNext() {
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
      }
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      }
      if (this.codeNumber == "" || this.codeNumber == null) {
        this.veriCode = "请输入验证码";
        this.showCodeTip = true;
      }
      if (this.phoneNumber && !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      }
      /* 用户登录 */
      if (
        this.phoneNumber &&
        /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber) == true &&
        this.isImgCodeTrue == true
      ) {
        this.showPhoneTip = false;
        this.showCodeTip = false;
        this.showImgTip = false;
        this.$axios
          .post("/ucenter/user/LoginForCode", {
            phone: this.phoneNumber,
            smsValidCode: this.codeNumber,
            regSource: 14,
            regDeviceType: 1,
            imgValidCode: this.imgCodeNumber,
          })
          .then((res) => {
            if (res.data.success == true) {
              if (res.data.retObj.firstReg !== 0) {
                localStorage.setItem("userId", res.data.retObj.id);
                this.isLogined = true;
                this.showLoginForm = false;
                this.$axios
                  .post("/operator/new-version/linkUserToInvitateCode", {
                    inviteCode: this.inviteCode,
                  })
                  .then((res) => {
                    if (res.data.success == true) {
                      $(".loginForm-box").css("display", "none");
                      $(".successForm-box").css("display", "block");
                    } else {
                    }
                  });
              } else {
                this.isNewUser = true;
              }
            } else {
              this.veriCode = "验证码输入错误";
              this.showCodeTip = true;
            }
          });
      }
    },
    //切换图形验证码
    changeImgCode() {
      // $("#img-code").attr("src", "/ucenter/api/authimage?" + Math.random());
      this.randomImg = `/ucenter/api/authimage?${Math.random()}`;
    },
    /* 发送验证码 */
    async sendCode() {
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      } else if (
        this.phoneNumber &&
        !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)
      ) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      } else {
        this.showPhoneTip = false;
      }
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
        return;
      }
      if (this.phoneNumber && /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.showPhoneTip = false;
        this.$axios
          .post("/ucenter/API/SMSService/SendRegKeyV2?t=" + Math.random(), {
            phoneNum: this.phoneNumber,
            imageCode: this.imgCodeNumber,
          })
          .then((res) => {
            if (res.data.success == false) {
              this.veriImg = "图形验证码错误";
              this.showImgTip = true;
            } else {
              this.isImgCodeTrue = true;
              this.showImgTip = false;
              this.isCounting = true;
              var time = 60;
              var countDown = setInterval(() => {
                time--;
                this.veriBtn = "重新发送" + time;
                if (time == 0) {
                  this.isCounting = false;
                  this.veriBtn = "获取短信验证码";
                  clearInterval(countDown);
                }
              }, 1000);
            }
          });
      }
    },
    toActivate() {
      window.location.href = "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/index";
    },
    toGuide() {
      window.location.href = "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/index";
    },
  },
};
</script>
<style lang="less" scoped>
.help-friend-page {
  font-family: Source Han Sans CN;
  .banner {
    position: relative;
    width: 100%;
    .helpfriend-banner {
      width: 100%;
      height: auto;
      vertical-align: middle;
    }
  }
  .wrapper {
    position: relative;
    width: 100%;
    height: auto;
    background-image: linear-gradient(#a074f7, #655be0);
    position: relative;
    padding-top: 100px;
    padding-bottom: 253px;
    .ball1 {
      display: block;
      position: absolute;
      top: 62px;
      right: 167px;
      width: 60px;
      height: 60px;
      background: url("../assets/img/ball-1.png") no-repeat center;
    }
    .ball2 {
      display: block;
      position: absolute;
      top: 1247px;
      left: -30px;
      width: 155px;
      height: 155px;
      background: url("../assets/img/ball-2.png") no-repeat center;
    }
    .small-bg {
      display: block;
      position: absolute;
      top: 160px;
      right: 0px;
      width: 614px;
      height: 702px;
      background: url("../assets/img/rightblur.png") no-repeat center;
      z-index: 0;
    }
  }
  .register {
    position: relative;
    width: 1279px;
    height: 435px;
    margin: 0 auto;
    background: url(../assets/img/publish-content-bg.png) no-repeat center;
    background-size: 100% 97%;
    padding-top: 66px;
    box-sizing: border-box;
    .register-title {
      position: absolute;
      left: 50%;
      top: -64px;
      transform: translateX(-50%);
      width: 1021px;
      height: 134px;
      line-height: 137px;
      background: url(../assets/img/invite/reg_title.png) no-repeat center;
      background-size: 100% auto;
      font-size: 36px;
      letter-spacing: 2px;
      color: #ffffff;
      z-index: 4;
    }
    .register-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      .reg-form {
        width: 488px;
        height: 236px;
        margin: 110px auto 0;
        .el-form-item {
          height: 56px;
        }
        .btn-message {
          display: inline-block;
          width: 200px;
          height: 62px;
          line-height: 62px;
          border-radius: 2px;
          border: solid 1px #8751ef;
          font-size: 24px;
          color: #6638bf;
        }
        .reg-next {
          width: 488px;
          height: 57px;
          line-height: 57px;
          background: url("../assets/img/invite/reg_next_pc.png") no-repeat
            center;
          background-size: 100% auto;
          letter-spacing: 2px;
          color: #6638bf;
          font-size: 22px;
        }
      }
    }
    .loginForm-box {
      display: flex;
      //   display: none;
      flex-direction: column;
      width: 488px;
      height: 273px;
      margin: 0 auto;
      .img-verify-wrap,
      .phone-verify-wrap,
      .phoneNum-verify-wrap {
        position: relative;
        display: flex;
        justify-content: space-between;
      }
      .phone-number,
      .veri-code,
      .imgCodeIpt {
        width: 488px;
        height: 48px;
        line-height: 48px;
        border: none;
        outline: none;
        border-radius: 2px;
        margin-bottom: 24px;
        font-size: 24px;
        padding-left: 16px;
        box-sizing: border-box;
      }
      .phone-number::placeholder {
        font-size: 20px;
        color: #d2d2d2;
      }
      .veri-code::placeholder {
        font-size: 20px;
        color: #d2d2d2;
      }
      .imgCodeIpt::placeholder {
        font-size: 20px;
        color: #d2d2d2;
      }
      .veri-code,
      .imgCodeIpt {
        width: 280px;
      }
      .btn-message {
        width: 200px;
        height: 46px;
        line-height: 46px;
        border-radius: 2px;
        border: solid 1px #8751ef;
        font-size: 24px;
        color: #6638bf;
        cursor: pointer;
      }
      .next-btn {
        width: 488px;
        height: 57px;
        line-height: 57px;
        background: url("../assets/img/invite/reg_next_pc.png") no-repeat center;
        background-size: 100% auto;
        letter-spacing: 2px;
        color: #6638bf;
        font-size: 22px;
        cursor: pointer;
        font-weight: bold;
      }
      .title {
        font-size: 16px;
      }
      .desc {
        font-size: 14px;
      }
      .veri-btn,
      .veri-btn-counting,
      #img-code {
        width: 200px;
        height: 48px;
        line-height: 48px;
        cursor: pointer;
        border: solid 1px #8751ef;
        color: #6638bf;
      }
      .veriPhone,
      .veriCode,
      .veriImg {
        position: absolute;
        left: 0;
        bottom: 7px;
        color: red;
        font-size: 13px;
      }
    }
    .new-user-box {
      width: 341px;
      height: 55px;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 8px;
      margin: 0 auto;
      line-height: 55px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      top: 132px;
      z-index: 10;
      color: #ffffff;
    }
    .successForm-box {
      width: 563px;
      height: 248px;
      margin: 0 auto;
      text-align: center;
      .info {
        width: 563px;
        height: 124px;
        padding: 23px 32px;
        border-radius: 22px;
        background-color: rgba(0, 0, 0, 0.2);
        font-size: 24px;
        line-height: 41px;
        letter-spacing: 2px;
        color: #ffffff;
        box-sizing: border-box;
        > p:first-child {
          span:last-child {
            display: inline-block;
            margin-left: 16px;
            font-size: 32px;
            letter-spacing: 3px;
            color: #ffd110;
            font-weight: bold;
          }
        }
      }
      .active-btn {
        display: block;
        width: 488px;
        height: 57px;
        margin: 30px auto 20px;
        line-height: 57px;
        background: url("../assets/img/invite/reg_next_pc.png") no-repeat center;
        background-size: 100% auto;
        letter-spacing: 2px;
        font-size: 22px;
        font-weight: bold;
        color: #6638bf;
        cursor: pointer;
        text-decoration:none;
      }
      > span,
      a {
        width: 110px;
        height: 16px;
        margin: 0 auto;
        font-size: 16px;
        letter-spacing: 2px;
        color: #6638bf;
        text-decoration: underline;
        cursor: pointer !important;
      }
    }
  }
  // 二维码
  .code-area {
    width: 100%;
    margin: 0 auto;
    padding: 90px 0 80px 0;
    text-align: center;
    > p:first-child {
      // width: 474px;
      height: 36px;
      font-size: 36px;
      line-height: 36px;
      letter-spacing: 2px;
      color: #ffffff;
    }
    img {
      margin: 56px 0 40px 0;
      vertical-align: middle;
    }
    .pc-p {
      display: block;
      height: 28px;
      line-height: 28px;
      font-size: 28px;
      letter-spacing: 1px;
      color: #ffffff;
    }
    > div {
      display: none;
    }
  }
  //   活动规则
  .activity-rule {
    width: 824px;
    height: 696px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    margin: 0 auto;
    color: #ffffff;
    padding-top: 22px;
    box-sizing: border-box;
    > p:first-child {
      font-size: 22px;
      letter-spacing: 4px;
    }
    .fs14 {
      font-size: 14px;
    }
    .lsp3 {
      letter-spacing: 3px;
    }
    .activity-time,
    .activity-group,
    .prize-rule {
      display: flex;
      align-items: center;
      margin-left: 59px;
      margin-top: 66px;
      img {
        width: 32px;
        height: 32px;
        margin-right: 28px;
      }
      .time-title,
      .group-title,
      .prize-title {
        width: 100px;
        height: 20px;
        font-size: 20px;
        line-height: 20px;
        letter-spacing: 4px;
        color: #fed590;
        margin-right: 20px;
      }
    }
    .activity-group,
    .prize-rule {
      margin-top: 28px;
      &.mb {
        margin-bottom: 26px;
      }
    }
    .prize-title {
      text-align: left;
      &.send {
        width: 152px;
      }
    }
    .prize-cont {
      width: 640px;
      height: 41px;
      font-size: 14px;
      line-height: 24px;
      text-align: left;
      margin-left: 124px;
    }
    .first-title {
      width: 655px;
      height: 33px;
      font-size: 14px;
      letter-spacing: 0px;
      color: #ffffff;
      margin-left: 121px;
      text-align: left;
      > span {
        font-size: 18px;
        font-weight: 700;
        color: #fed590;
      }
      &.mt {
        margin-top: 14px;
      }
    }
    .notices {
      width: 78px;
      height: 16px;
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 3px;
      color: #ffffff;
      margin-left: 59px;
      margin-top: 48px;
      margin-bottom: 24px;
    }
  }
  @media screen and (max-width: 750px) {
    .banner {
      video {
        display: none;
      }
      img {
        display: inline-block;
        width: 100%;
        height: auto;
        vertical-align: middle;
      }
    }
    .wrapper {
      padding-top: 40px;
      padding-bottom: 126px;
      .ball1 {
        display: none;
      }
      .ball2 {
        display: none;
      }
      .small-bg {
        display: none;
      }
    }
    .register {
      width: 280px;
      height: 216px;
      background: #c9b3ff;
      padding-top: 22px;
      .register-title {
        top: -16px;
        width: 283px;
        height: 34px;
        font-size: 11px;
        line-height: 35px;
        letter-spacing: 0px;
      }
      .loginForm-box {
        width: 244px;
        height: 154px;
        .phone-number,
        .veri-code,
        .imgCodeIpt {
          width: 244px;
          height: 32px;
          line-height: 32px;
          border-radius: 1px;
          font-size: 12px;
          padding-left: 8px;
          margin-bottom: 12px;
        }
        
        .phone-number {
          height: 28px;
          line-height: 28px;
        }
        .phone-number::placeholder {
          font-size: 12px;
          color: #d2d2d2;
        }
        .veri-code,
        .imgCodeIpt {
          width: 140px;
        }
        .veri-code::placeholder {
          font-size: 12px;
          color: #d2d2d2;
        }
        .imgCodeIpt::placeholder {
          font-size: 12px;
          color: #d2d2d2;
        }
        .veri-btn,
        .veri-btn-counting,
        .btn-message,
        #img-code {
          width: 100px;
          height: 32px;
          line-height: 32px;
        }
        .btn-message {
          height: 30px;
          line-height: 30px;
          border-radius: 1px;
          font-size: 12px;
          color: #fff258;
          border: solid 1px #fff258;
        }
        .next-btn {
          width: 244px;
          height: 29px;
          line-height: 29px;
          font-size: 11px;
          letter-spacing: 1px;
        }
        .veriPhone,
        .veriCode,
        .veriImg {
          position: absolute;
          left: 0;
          bottom: 1px;
          color: red;
          font-size: 7px;
        }
      }
      .new-user-box {
          width: 270px;
          height: 35px;
          line-height: 35px;
          font-size: 12px;
          top: 80px;
          padding: 0 10px;
          box-sizing: border-box;
        }
      .successForm-box {
        width: 265px;
        height: 124px;
        margin: 0 auto;
        text-align: center;
        .info {
          width: 265px;
          height: 62px;
          padding: 10px 18px;
          border-radius: 11px;
          font-size: 12px;
          line-height: 21px;
          letter-spacing: 0px;
          > p:first-child {
            span:last-child {
              display: inline-block;
              margin-left: 8px;
              letter-spacing: 0px;
              color: #ffd110;
              font-weight: bold;
              font-size: 12px;
            }
          }
        }
        .active-btn {
          width: 244px;
          height: 29px;
          margin: 13px auto 9px;
          line-height: 29px;
          letter-spacing: 1px;
          font-size: 11px;
        }
        > span,
        a {
          width: 68px;
          height: 10px;
          margin: 0 auto;
          font-size: 10px;
          line-height: 10px;
          letter-spacing: 1px;
        }
      }
    }
    // 二维码
    .code-area {
      padding: 33px 0 60px 0;
      text-align: center;
      > p:first-child {
        // width: 474px;
        height: 20px;
        line-height: 20px;
        font-size: 20px;
        letter-spacing: 1px;
      }
      img {
        width: 150px;
        height: 150px;
        margin: 28px 0 19px 0;
        vertical-align: middle;
      }
      .pc-p {
        display: none;
      }
      > div {
        display: block;
        line-height: 27px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
      }
    }
    //   活动规则
    .activity-rule {
      width: 280px;
      height: 400px;
      border-radius: 4px;
      padding-top: 23px;
      box-sizing: border-box;
      > p:first-child {
        font-size: 11px;
        letter-spacing: 2px;
      }
      .fs14 {
        font-size: 7px;
      }
      .lsp1 {
        letter-spacing: 1px;
      }
      .activity-time,
      .activity-group,
      .prize-rule {
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-top: 30px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 14px;
        }
        .time-title,
        .group-title,
        .prize-title {
          width: 50px;
          height: 10px;
          font-size: 10px;
          line-height: 10px;
          letter-spacing: 2px;
          margin-right: 10px;
        }
      }
      .activity-group,
      .prize-rule {
        margin-top: 14px;
        &.mb {
          margin-bottom: 11px;
        }
      }
      .prize-title {
        text-align: left;
        &.send {
          width: 80px;
        }
      }
      .prize-cont {
        width: 220px;
        height: 41px;
        font-size: 7px;
        line-height: 12px;
        letter-spacing: 1px;
        margin-left: 46px;
      }
      .first-title {
        width: 223px;
        height: 22px;
        font-size: 7px;
        letter-spacing: 0px;
        margin-left: 46px;
        text-align: left;
        > span {
          font-size: 9px;
          font-weight: 700;
        }
        &.mt {
          margin-top: 14px;
        }
      }
      .notices {
        width: 78px;
        height: 8px;
        font-size: 8px;
        line-height: 8px;
        letter-spacing: 2px;
        color: #ffffff;
        margin-left: 15px;
        margin-top: 20px;
        margin-bottom: 12px;
        text-align: left;
      }
    }
  }
}
</style>
<style>
.help-friend-page .el-input__inner {
  height: 48px;
}
.help-friend-page .veryfi-code {
  margin-bottom: 37px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelpFriendPage.vue